import art1 from "../assets/clementine.png";
import art2 from "../assets/OTGW.png";
import art3 from "../assets/luna_moth.png";
import art4 from "../assets/charcoal_bodies.png";
import art5 from "../assets/zuko.png";
import art6 from "../assets/viktor_arcane.png";
import art7 from "../assets/apple.png";
import art1_2 from "../assets/clementines_OG.JPEG";
import art3_2 from "../assets/lunamoth_sold.JPEG";
import art7_2 from "../assets/apple_OG.JPEG";
import art4_2 from "../assets/charcoalfigures_OG.JPEG";
import art8 from "../assets/nosferatu.png";
import art9 from "../assets/pomegranite.png";
import art9_2 from "../assets/pomegranite_OG.JPEG";
import art10 from "../assets/watermelon.png";
import art10_2 from "../assets/watermelon_OG.JPEG";
import art11 from "../assets/grapes.png";
import art11_2 from "../assets/grapes_OG.JPEG";
import art12 from "../assets/lemons.png";
import art13 from "../assets/achilles.png";

export const shopItems = [
  {
    id: "otgw",
    title: "Over the Garden Wall - Rubber Hose",
    medium: "Heavy Cardstock - Cotton Paper",
    images: [art2],
    printSize: "5x7\"",
    printPrice: "$10.00",
    originalPrice: null,
    fanFavorite: true,
    description: "Fan art inspired by Over the Garden Wall, drawn in a rubber hose animation style in Procreate.",
  },
  {
    id: "zuko",
    title: "Zuko",
    medium: "Heavy Card Stock - Gloss Paper",
    images: [art5],
    printSize: "8x10\"",
    printPrice: "$20.00",
    originalPrice: null,
    fanFavorite: false,
    description: "Portrait of Zuko from Avatar: The Last Airbender, painted digitally in Procreate.",
  },
  {
    id: "achilles",
    title: "Song of Achilles",
    medium: "Heavy Card Stock - Gloss Paper",
    images: [art13],
    printSize: "8x10\"",
    printPrice: "$20.00",
    originalPrice: null,
    fanFavorite: false,
    description: "Achilles from the Iliad after Patroclus is killed.",
  },
  {
    id: "viktor-arcane",
    title: "Viktor - Arcane",
    medium: "Heavy Card Stock - Gloss Paper",
    images: [art6],
    printSize: "8x10\"",
    printPrice: "$20.00",
    originalPrice: null,
    fanFavorite: false,
    description: "Portrait of Viktor from Arcane, painted digitally in Procreate.",
  },
  {
    id: "clementines",
    title: "Clementines",
    medium: "Oil Paint original, Heavy Card Stock - Felt Paper print",
    images: [art1, art1_2],
    printSize: "8x10\"",
    printPrice: "$20.00",
    originalSize: "5x7\"",
    originalPrice: "$250.00",
    fanFavorite: true,
    description: "A still life oil painting of clementines on canvas board.",
  },
  {
    id: "nosferatu",
    title: "Nosferatu Taro Card",
    medium: "Heavy Card Stock - Gloss Paper",
    images: [art8],
    printSize: "8x10\"",
    printPrice: "$20.00",
    fanFavorite: false,
    description: "A Nosferatu (2024) taro card farnart of Ellen Hutter and Count Orlok.",
  },
  {
    id: "luna-moth",
    title: "Luna Moth",
    medium: "Oil Paint original, Heavy Cardstock - Cotton Paper print",
    images: [art3, art3_2],
    printSize: "5x7\"",
    printPrice: "$10.00",
    originalSize: "8x8\"",
    originalPrice: "SOLD",
    fanFavorite: true,
    description: "A detailed oil painting of a luna moth. The original has been sold.",
  },
  {
    id: "apple",
    title: "Apple",
    medium: "Oil Paint original, Heavy Card Stock - Felt Paper print",
    images: [art7, art7_2],
    printSize: "8x10\"",
    printPrice: "$20.00",
    originalSize: "5x7\"",
    originalPrice: "$200.00",
    fanFavorite: false,
    description: "A small oil painting study of an apple on canvas board.",
  },
  {
    id: "figure-drawing",
    title: "Live Figure Drawing - 4 Bodies",
    medium: "Charcoal original, Heavy Cardstock - Cotton Paper print",
    images: [art4, art4_2],
    printSize: "5x7\"",
    printPrice: "$10.00",
    originalPrice: null,
    fanFavorite: false,
    description: "Figure drawing done from live model sessions in charcoal.",
  },
  {
    id: "pomegranite",
    title: "Pomegranite",
    medium: "Oil Paint original, Heavy Card Stock - Felt Paper print",
    images: [art9, art9_2],
    printSize: "8x10\"",
    printPrice: "$20.00",
    originalSize: "5x7\"",
    originalPrice: "$200.00",
    fanFavorite: false,
    description: "A small oil painting study of a pomegranite on canvas board.",
  },
  {
    id: "watermelon",
    title: "Watermelon",
    medium: "Oil Paint original, Heavy Card Stock - Felt Paper print",
    images: [art10, art10_2],
    printSize: "8x10\"",
    printPrice: "$20.00",
    originalSize: "5x7\"",
    originalPrice: "$200.00",
    fanFavorite: false,
    description: "A small oil painting study of a watermelon on canvas board.",
  },
  {
    id: "grapes",
    title: "Grapes",
    medium: "Oil Paint original, Heavy Card Stock - Felt Paper print",
    images: [art11, art11_2],
    printSize: "8x10\"",
    printPrice: "$20.00",
    originalSize: "5x7\"",
    originalPrice: "$150.00",
    fanFavorite: false,
    description: "A small oil painting study of grapes on canvas board.",
  },
  {
    id: "lemons",
    title: "Lemons",
    medium: "Oil Paint original, Heavy Card Stock - Felt Paper print",
    images: [art12],
    printSize: "8x10\"",
    printPrice: "$20.00",
    originalSize: "5x7\"",
    originalPrice: "$150.00",
    fanFavorite: false,
    description: "A small oil painting study of lemons on canvas board.",
  },
];